import { Component, inject } from '@angular/core';

import { SurveyEditorService } from '../../../../services/survey-editor.service';

@Component({
  selector: 'empathy-file-upload-settings',
  templateUrl: 'file-upload-settings.component.html',
  styleUrls: ['./file-upload-settings.component.scss', './_file-upload-settings-theme.component.scss']
})
export class FileUploadSettingsComponent {
  activeQuestion = inject(SurveyEditorService).surveyEditor$().activeQuestion;
}
